import React, { useEffect, useState } from 'react';
import './scss/index.scss';
import KeyValue from '../keyValue';
import SectionTitle from '../../../components/common/sectionTitle/sectionTitle';
import { withRouter } from 'react-router-dom';
import { getStartupApplicationList , deepTechRegenerate  } from '../../../dependencies/services/startupApplicationService';
import { getStartupApplicationView } from '../../../dependencies/services/getStartupApplicationView';
import connect from 'react-redux/es/connect/connect';
import EntityDataRow from '../../common/EntityDataRow';
import Button from '../../common/Button';
import ActionModal from '../modal';
import { ROLES } from '../../../constants/Roles';
import { storage } from '../../../dependencies/store/storage';


const EntityDetails = (props) => {

    const userRole = storage.getUserRole();
    const [modalValue, setModalValue] = useState(false);
    const [buttonValue, setButtonValue] = useState('');
    const sAppId = props.match.params.id;
    const swsCondition = props.startupApplicationViewData.swsId || props.startupApplicationViewData.applReqId || false

    useEffect(() => {
        props.getStartupApplicationView({
            sAppId: sAppId
        });
    }, []);

    if (props.startupApplicationViewData.directors !== undefined) {
        var directData = props.startupApplicationViewData.directors.map(item => {
            return (<div className="directors-list"><KeyValue items={item} /></div>)
        })
    }

    const toggleActionModal = () => {
        setModalValue(!modalValue);
    }

    const callApi = () => {
        props.getStartupApplicationView({
            sAppId: sAppId
        });
    }

    const submitAction = (name) => {
        toggleActionModal();
        setButtonValue(name)

    }

    const isValidUser = userRole === ROLES.SUPER_ADMIN || userRole === ROLES.ADMIN;
    const isValidUserForArchive = userRole === ROLES.SUPER_ADMIN;

     const deepTechEnabled =
    props.startupApplicationViewData?.deepTechApplied === true ||
    props.startupApplicationViewData?.deepTechApplied === "true";

  const submitDeepTechApprove = () => {
    const applicationId =
      props.startupApplicationViewData?.applicationId ||
      props.startupApplicationViewData?.id ||
      sAppId;
    if (!applicationId) {
      return;
    }

    props.deepTechRegenerate({ id: applicationId, status: "APPROVE" }).then((result) => {
      if (result && result.status) {
        callApi();
      }
    });
  };


    return (
        <div className="p30">
            <SectionTitle>Startup India : Registration Form{((props.startupApplicationViewData.swsId) ? (' (NSWS)') : (''))}</SectionTitle>
            <div className="entity-detail-wrap">
                <div className="entity-detail-inner p-20 mb-15">
                    <h3>Nature of the Entity</h3>
                    <KeyValue items={props.startupApplicationViewData.natureOfEntity ? props.startupApplicationViewData.natureOfEntity : ''} />
                </div>

                 {props?.startupApplicationViewData?.deepTechApplied && (
                    <div className="entity-detail-inner p-20 mb-15">
                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', borderBottom: "solid #e7e7e7 1px" ,marginBottom: '15px' }}>
                            <h3 style={{ margin: 0, padding: 0 ,width: "50%",
    borderBottom: "none"
}}>Deeptech Category</h3>
                            <span>
                                {props?.startupApplicationViewData?.deepTechApplied ? "Yes" : "No"}
                            </span>
                        </div>
                        {props?.startupApplicationViewData?.deepTechApplied && (
                            <KeyValue
                                items={props.startupApplicationViewData.deepTechDetails || {}}
                            />
                        )}

                    </div>
                )}


                <div className="entity-detail-inner p-20 mb-15">
                    <h3>Full Address (Office)</h3>
                    <KeyValue items={props.startupApplicationViewData.officeAddress ? props.startupApplicationViewData.officeAddress : ''} />
                </div>
                <div className="entity-detail-inner p-20 mb-15">
                    <h3>Authorized Representative Details</h3>
                    <KeyValue items={props.startupApplicationViewData.autherizeRepresentativeDetails ? props.startupApplicationViewData.autherizeRepresentativeDetails : ''} />
                </div>
                <div className="entity-detail-inner p-20 mb-15">
                    <h3>Director(s) / Partner(s) Details</h3>
                    <EntityDataRow className="" title={'Number of Directors / Partners	'} description={Object.values(props.startupApplicationViewData ? props.startupApplicationViewData.directors : '').length} />
                    {directData}
                </div>
                <div className="entity-detail-inner p-20 mb-15">
                    <h3>Information Required</h3>
                    <KeyValue items={props.startupApplicationViewData.informationRequired ? props.startupApplicationViewData.informationRequired : ''} />
                </div>
                {
                    props.startupApplicationViewData.beneficiary && <div className="entity-detail-inner p-20 mb-15">
                        <h3>Beneficiary</h3>
                        <KeyValue items={props.startupApplicationViewData.beneficiary ? props.startupApplicationViewData.beneficiary : ''} />
                    </div>
                }

                {(props.startupApplicationViewData.preCertified === false) ?
                    <div className="entity-detail-inner p-20 mb-15">
                        <h3>Self Certification</h3>
                        <KeyValue items={props.startupApplicationViewData.selfCertificate ? props.startupApplicationViewData.selfCertificate : ''} />
                    </div> : ''}


            </div>
            {isValidUser &&
        (props.startupApplicationViewData &&
        props.startupApplicationViewData.archived === false ? (
          // ✅ SUBMIT
          props.startupApplicationViewData.buttonStatus === "SUBMIT" ? (
            <div className="allButton mb-30">
              {isValidUserForArchive && (
                <Button
                  id="offline"
                  className="bttn blue normal"
                  type="button"
                  onClick={() => submitAction("ARCHIVE")}
                  text="Archive"
                />
              )}

              <Button
                className="bttn green normal"
                type="button"
                onClick={() => submitAction("APPROVE")}
                text="Approved"
              />

              <Button
                className="bttn red normal"
                type="button"
                onClick={() => submitAction("REJECT")}
                text="Reject"
              />

              <Button
                className="bttn yellow normal"
                type="button"
                onClick={() => submitAction("INCOMPLETE")}
                text="Incomplete"
              />

              {!swsCondition && (
                <Button
                  className="bttn voilet normal"
                  type="button"
                  onClick={() => submitAction("ON_HOLD")}
                  text="On Hold"
                />
              )}
               {isValidUser && deepTechEnabled && props.startupApplicationViewData?.archived === false ? (
        // <div className="allButton mb-30">
          <Button
            className="bttn green normal"
            type="button"
            onClick={submitDeepTechApprove}
            text="Approve (Without Deeptech)"
          />
        // </div>
      ) : null}

            </div>
          ) : // ✅ EXPIRED (ONLY APPROVE + REJECT)
          props.startupApplicationViewData.buttonStatus === "EXPIRED" ? (
            <div className="allButton mb-30">
              <Button
                className="bttn green normal"
                type="button"
                onClick={() => submitAction("APPROVE")}
                text="Approved"
              />

              <Button
                className="bttn red normal"
                type="button"
                onClick={() => submitAction("REJECT")}
                text="Reject"
              />
            </div>
          ) : // ✅ OTHER STATUSES
          props.startupApplicationViewData.buttonStatus === "DRAFT" ||
            props.startupApplicationViewData.buttonStatus === "APPROVE" ||
            props.startupApplicationViewData.buttonStatus === "REJECT" ||
            props.startupApplicationViewData.buttonStatus === "CANCELLED" ? (
            isValidUserForArchive && (
              <div className="allButton mb-30">
                <Button
                  id="offline"
                  className="bttn blue normal"
                  type="button"
                  onClick={() => submitAction("ARCHIVE")}
                  text="Archive"
                />
              </div>
            )
          ) : props.startupApplicationViewData.buttonStatus === "INCOMPLETE" ? (
            <div className="allButton mb-30">
              {isValidUserForArchive && (
                <Button
                  id="offline"
                  className="bttn blue normal"
                  type="button"
                  onClick={() => submitAction("ARCHIVE")}
                  text="Archive"
                />
              )}

              <Button
                className="bttn red normal"
                type="button"
                onClick={() => submitAction("REJECT")}
                text="Reject"
              />

              <Button
                className="bttn yellow normal"
                type="button"
                onClick={() => submitAction("INCOMPLETE")}
                text="Incomplete"
              />
            </div>
          ) : props.startupApplicationViewData.buttonStatus === "ON_HOLD" ? (
            <div className="allButton mb-30">
              <Button
                className="bttn green normal"
                type="button"
                onClick={() => submitAction("SUBMIT")}
                text="Unhold"
              />
            </div>
          ) : (
            ""
          )
        ) : (
          ""
        ))}

            {modalValue ?
                <ActionModal
                    modalValue={modalValue}
                    toggleActionModal={toggleActionModal}
                    callApi={callApi}
                    actionValue={buttonValue}
                    id={props.startupApplicationViewData
                        ?
                        props.startupApplicationViewData.applicationId : ''}
                /> : null
            }
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        startupApplicationDataState: state.startupApplicationList.startupData,
        startupApplicationViewData: state.startupSectionView.startupAppData,
    }
}
export default connect(mapStateToProps, { getStartupApplicationList, deepTechRegenerate, getStartupApplicationView })(withRouter(EntityDetails))